<template>
	<div>
		<PagePadding>
			<SubtitleText><slot /></SubtitleText>
		</PagePadding>
		<div class="mt-2 flex scroll-pl-4 overflow-x-scroll">
			<PagePadding class="inline-flex gap-1.5">
				<TransitionGroup
					enterActiveClass="transition-all duration-500"
					enterFromClass="-ml-40 opacity-0"
				>
					<BaseCard
						v-for="item in liveDrop"
						:key="item.time"
						class="inline-flex shrink-0 items-center gap-4 py-2 pr-4 pl-2 last-of-type:mr-4"
					>
						<ItemIcon
							:src="item.src"
							:preloader="item.preloader || undefined"
							name=""
							size="sm"
						/>
						<div class="flex shrink-0 flex-col">
							<div
								class="text-label-secondary max-w-30 truncate text-xs font-medium whitespace-nowrap uppercase"
							>
								{{ item.modelName }}
							</div>
							<CoinPrice :price="item.price" class="mt-1" size="xs" />
						</div>
					</BaseCard>
				</TransitionGroup>
			</PagePadding>
		</div>
	</div>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import SubtitleText from '@/components/SubtitleText.vue'
import PagePadding from './PagePadding.vue'
import BaseCard from './BaseCard.vue'
import ItemIcon from './ItemIcon.vue'
import CoinPrice from './CoinPrice.vue'

const { t } = useI18n({
	messages: {
		en: {
			live: 'live drop'
		},
		ru: {
			live: 'Последние выигрыши'
		}
	}
})

defineProps<{
	liveDrop: {
		src: string
		preloader?: string | null
		modelName: string
		price: number
		time: number
	}[]
}>()
</script>
